
















































import {Component, Prop, Vue} from "vue-property-decorator";
import ImageUploader from "@/components/UI/ImageUploader.vue";
import MainItem from "@/pages/ItemManagementPage/ItemDetail/MainItem.vue";
import NameInputs from "@/components/UI/NameInputs.vue";

@Component({
    components: {
        ImageUploader,
        NameInputs,
    }
})
export default class CondimentItem extends MainItem {
    @Prop() private isButtonShow!: boolean;
    @Prop() private isDefault!: boolean;
    @Prop() private index!: number;
    // memo
    //   MainItemを継承している。
    //   メイン商品とオプション商品の挙動が完全に同じで良いため。
    //   少しでも処理を分けたくなったら継承をやめよう。（Vueの継承は実装が絡むと不安定なため）

    get dispHeading(){
        return this.index == 0;
    }
}
